import React from 'react'
import { getUrl, getDescText, getDateAnnouncedShort } from '../../common/services/builders'
import entriesReducer from '../../common/services/reducers/entries';

function PublicFundedProjectsListerSearchItem({ entry, settings }) {

    function getPDFDowloads(arr)
    {
        var listOfPDFDownloads = arr.map((download, index) => 
            <a key={index} href={download.sys.uri}><i className="fas fa-file-pdf"></i>PDF Summary</a>
        );
        return listOfPDFDownloads
    }



    function renderIndustries (entry)
    {

        if (entry && entry.industries){

            if(!Array.isArray(entry.industries)){
                return <span className="tag small">{entry.industries.name}</span> 
            }
            else{
                return entry.industries.map((e, index) => <span key={index} className="tag small">{e.name}</span>)
            }

        }

    }


    return (
        <div className="search-result">
            {/*<div className="row">
                <div className="small-6 column">
                    {renderTypeTag(entry)}
                </div>
                <div className="small-6 column text-right">
                    {renderMemberTag(entry)}
                </div>
            </div>*/}

            <div className="row column">
                <h4><a href={getUrl(entry)}>{entry.projectTitle}</a></h4>

                <span className="date">ACRONYM: <strong>{entry.acronym}</strong></span>

                <span className="date">Industries: {renderIndustries(entry)}</span>


                {/* <BuildIndustriesList industries={entry.industries} /> */}

                {/* <p><strong>Reference:</strong> {entry.reference}</p>
                 */}

                {/* <p><strong>Date Closed:</strong> {entry.dateClosed}</p> */}

                {/* <p><strong>Status:</strong> {entry.status}</p> */}

                {/* <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span> */}

                {/* <span className="date">
                    <span>Announced: </span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getDateAnnouncedShort(entry)}
                </span> */}

                {/* <span className="date">
                    <span>Status: </span>
                    {entry.status}
                </span> */}


                {/* <p>{getPDFDowloads(entry.pdfDownload)}</p> */}

                {/*<span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg></span>*/}

            </div>
        </div>
    )
    
}

function renderMemberTag(entry) {
    if (entry.sys.contentTypeId == 'weldasearch'){
        return <span className="category--tag">All members</span>
    }
    if(entry.sys.metadata.permission){
        switch (entry.sys.metadata.permission) {
            case 'OPEN':
                return <span className="category--tag">All members</span>
            case 'IM':
                return <span className="category--tag">Industrial members</span>
            case 'PRO':
                return <span className="category--tag">Professional members</span>	
            default:
                return <span className="category--tag">Public</span>
        }
    }
    else{
        return <span className="category--tag">Public</span>
    }
}

function renderTypeTag(entry){
    if(entry.sys.dataFormat == 'webpage'){
        return <span className="category--tag">Webpage</span>
    }
    else{
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>
    }
}

export default PublicFundedProjectsListerSearchItem;